import apiClient from "../api-client.js";
import { downloadCSV, getLogCSVHeaders, logToCSVRow, LOG_MODULE_LABELS } from "../utils/csvUtils.js";

// The backend remembers where each dataset's last download ended; both modes move that mark forward.

const ROLE_LABELS = {
  agency_admin: "Administrador de agencia",
  consultant: "Consultor",
  client: "Usuario cliente",
};

const formatDateTime = (value) => (value ? new Date(value).toLocaleString("es-ES") : "");
const formatDate = (value) => (value ? new Date(value).toLocaleDateString("es-ES") : "");
const yesNo = (value) => (value ? "Sí" : "No");

export const formatExportDate = (value) =>
  new Date(value).toLocaleString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

export const EXPORT_DATASETS = {
  logs: {
    label: "Logs",
    description: "Acciones POST, PATCH y DELETE de la plataforma",
    filename: "logs",
    headers: getLogCSVHeaders(),
    toRow: (log) => logToCSVRow(log, LOG_MODULE_LABELS),
  },
  agencies: {
    label: "Agencias",
    description: "Listado de agencias con sus administradores",
    filename: "agencias",
    headers: [
      "ID", "Nombre", "Estado", "Tipo", "Email", "Teléfono", "Web", "Ubicación",
      "Administradores", "Consultores", "Clientes", "Fecha de alta",
    ],
    toRow: (agency) => [
      agency.id, agency.name, agency.status, agency.agency_type, agency.email, agency.phone,
      agency.website, agency.location, agency.admins, agency.consultants_count,
      agency.clients_count, formatDateTime(agency.created_at),
    ],
  },
  users: {
    label: "Usuarios",
    description: "Administradores de agencia, consultores y usuarios cliente",
    filename: "usuarios",
    headers: [
      "ID", "Nombre", "Apellidos", "Email", "Teléfono", "Rol", "Agencia", "Clientes", "Fecha de alta",
    ],
    toRow: (user) => [
      user.id, user.first_name, user.last_name, user.email, user.telephone,
      ROLE_LABELS[user.role] || user.role, user.agency_name, user.clients, formatDateTime(user.created_at),
    ],
  },
  clients: {
    label: "Clientes",
    description: "Clientes con sus usuarios cliente",
    filename: "clientes",
    headers: [
      "ID", "Nombre", "Agencia", "Web", "Sector", "Razón social", "CIF/NIF", "Contacto",
      "Email de contacto", "Teléfono de contacto", "Estado onboarding", "Inicio de contrato",
      "Usuarios cliente", "Archivado", "Fecha de alta",
    ],
    toRow: (client) => [
      client.id, client.name, client.agency_name, client.website, client.sector, client.legal_name,
      client.tax_id, client.contact_name, client.contact_email, client.contact_phone,
      client.onboarding_status, formatDate(client.contract_start_date), client.client_users,
      yesNo(client.is_archived), formatDateTime(client.created_at),
    ],
  },
};

export const CSV_EXPORTS_QUERY_KEY = ["csv-exports-summary"];

export const getExportsSummary = async () => {
  const response = await apiClient.get("/exports/");
  return response.data;
};

/** Downloads the CSV and returns how many rows it had (0 = nothing new, no file). */
export const runExport = async (dataset, mode) => {
  const response = await apiClient.post("/exports/", { dataset, mode });
  const { results = [], count = 0 } = response.data;
  if (count === 0) return 0;

  const config = EXPORT_DATASETS[dataset];
  const timestamp = new Date().toISOString().split("T")[0];
  const suffix = mode === "full" ? "completo" : "incremental";
  downloadCSV(
    [config.headers, ...results.map(config.toRow)],
    `${config.filename}_${suffix}_${timestamp}`
  );
  return count;
};
